<template>
  <div class="confirmation-sent-section">
    <h3 class="confirmation-sent-section__title">
      {{ $tc('SignupPage.ConfirmationSentPage.title') }}
    </h3>
    <div
      class="confirmation-sent-section__message"
      v-html="$tc('SignupPage.ConfirmationSentPage.message')"
    />

    <action-buttons-section
      class="confirmation-sent-section__action-buttons"
      scrollTargetSelector=".confirmation-sent-section"
      :visible="true"
    >
      <atom-input-button
        :linkText="$tc('SignupPage.ConfirmationSentPage.reEnter')"
        :isDisabled="false"
        colorType="secondary"
        @push="onMoveToEmailAuthentication"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

export default defineComponent({
  name: 'ConfirmationSentSection',
  components: {
    ActionButtonsSection,
    AtomInputButton,
  },
  methods: {
    onMoveToEmailAuthentication() {
      this.$emit('onMoveToEmailAuthentication')
    },
  },
})
</script>

<style lang="scss" scoped>
.confirmation-sent-section {
  padding: 80px 16px;

  &__title {
    @include fontSetTextMedium(17);

    line-height: 1.41;
    font-weight: 500;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;
  }

  &__message {
    margin: 24px 0;
    @include fontSetTextMedium();

    font-feature-settings: 'palt' on;

    ::v-deep {
      > * + * {
        margin-top: 1.5em;
      }
    }
  }

  &__action-buttons {
    bottom: 0;
  }
}
</style>
